import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import PopupForm from "../../../../../components/PopupForm";
import { quillModules, quillEditorContentStyle } from "../../../../../components/shared/quillConfig";

function EditCommentModal({ isOpen, onClose, commentId, content, onChange, onSubmit }) {
    return (
        <PopupForm isShowForm={isOpen} setIsShowForm={onClose} title="Chỉnh sửa bình luận">
            <div className="mb-4">
                <label className="text-lg font-bold mb-2 ml-1 text-white">Nội dung</label>
                <ReactQuill
                    className="main-comment-quill"
                    key={commentId}
                    theme="snow"
                    value={content}
                    onChange={onChange}
                    style={{ background: "#fff", color: "#000", marginBottom: "8px" }}
                    modules={quillModules}
                />
                <style>{quillEditorContentStyle}</style>
            </div>
            <div className="flex justify-end mt-4">
                <button
                    onClick={onSubmit}
                    className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-200"
                >
                    Cập nhật
                </button>
            </div>
        </PopupForm>
    );
}

export default EditCommentModal;

